module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"onlyDesktop":"This system only supports desktop browser, Please switch to a desktop browser before proceeding!"},"al":{"onlyDesktop":"Ky sistem suporton vetëm shfletues në desktop, ju lutemi kaloni në një shfletues desktop përpara se të vazhdoni!"}}')
  delete Component.options._Ctor
}
